
import Vue from "vue";
import Employee from "@/interface/Employee";

export default Vue.extend({
  props: {
    employee: {
      type: Object as () => Employee,
    },
  },
});
